import { ViewModal } from "./ViewModal";

export default ViewModal;
